import { render, staticRenderFns } from "./MyApproval.vue?vue&type=template&id=05aa00e4&scoped=true&"
import script from "./MyApproval.vue?vue&type=script&lang=js&"
export * from "./MyApproval.vue?vue&type=script&lang=js&"
import style0 from "./MyApproval.vue?vue&type=style&index=0&id=05aa00e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa00e4",
  null
  
)

export default component.exports